import { isEqual, sortBy } from "@s-libs/micro-dash";
import dayjs from "dayjs";

const getFormValues = (assignment) => {
  /**
   * For valid comparison, transform activity_members, assignment_classrooms, &
   * assignment_groups because their shape changes when selected, and sort
   * since micro-dash isEqual is sensitive to the order of arrays. Example:
   * const a = [{ one: 1, two: 2 }, { three: 3, four: 4 }];
   * const b = [{ three: 3, four: 4 }, { one: 1, two: 2 }];
   * isEqual(a, b) // false
   */
  return {
    activity_members: sortBy(
      assignment.activity_members.map((activityMember) => ({
        content_id: activityMember.content_id,
      })),
      (activityMember) => activityMember.content_id,
    ),
    assignment_classrooms: sortBy(
      assignment.assignment_classrooms.map((classroom) => ({
        name: classroom.name,
        unique_id: classroom.unique_id,
      })),
      (classroom) => classroom.unique_id,
    ),
    assignment_groups: sortBy(
      assignment.assignment_groups.map((assignmentGroup) => ({
        name: assignmentGroup.name,
        users: sortBy(
          assignmentGroup.users.map((user) => ({ unique_id: user.unique_id })),
          (user) => user.unique_id,
        ),
      })),
      (assignmentGroup) => assignmentGroup.name,
    ),
    assignment_config: assignment.assignment_config,
    default_reading_level: assignment.default_reading_level,
    instructions: assignment.instructions,
    is_reading_level_locked: assignment.is_reading_level_locked,
    title: assignment.title,
  };
};

const getIsAssignmentBuilderFormDirty = (reference, comparison) => {
  const referenceValues = getFormValues(reference);
  const comparisonValues = getFormValues(comparison);

  // React Aria uses milliseconds while monolith does not, so compare down to minutes.
  const hasDateGoesLiveChange =
    reference.date_goes_live || comparison.date_goes_live
      ? !dayjs(reference.date_goes_live).isSame(
          comparison.date_goes_live,
          "minute",
        )
      : false;
  const hasFormValueChanges = !isEqual(referenceValues, comparisonValues);

  return hasFormValueChanges || hasDateGoesLiveChange;
};

export default getIsAssignmentBuilderFormDirty;
